import './App.css';
import Home from './conponents/Home';

function App() {
  return (
    <>
    <Home/>
    </>
  );
}

export default App;
